import ApiService from '../api.services';

const BudgetService = {
    upload: async function(formData) {
      try {
        const response = await ApiService.post('/api/budget', formData, {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
        })
      } catch (error) {
        throw error;
      }
    },

    list: async function () {
        try {
            const response = await ApiService.get('/api/budget');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default BudgetService;

export { BudgetService };

